import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { FormValidationService } from "src/app/core/services/form-validation.service";
import { FocusPayEntityType } from "src/app/shared/models/enums/focuspay-entity-type.enum";
import { FocusPayApplication } from "src/app/shared/models/FocusPay/FocusPayApplication.item";

@Component({
	selector: "app-application-legal-information",
	templateUrl: "./application-legal-information.component.html",
	styleUrls: ["../../focuspay.style.scss"],
})
export class ApplicationLegalInformationComponent implements OnInit {
	@Input() application: FocusPayApplication;
	@Input() readOnly: boolean;
	@Output() applicationEmitter = new EventEmitter<FocusPayApplication>();

	@Output() displayModal = new EventEmitter<string>();
	@Output() inputActionEmitter = new EventEmitter<any>();
	@Output() sectionCompleteEmitter = new EventEmitter<any>();

	sectionStatus: Subject<any> = new Subject<any>();

	applicationAddressLegalDifferentFromBusiness: boolean = false;
	applicationAddressLegalDifferentFromBusinessControl: UntypedFormControl;
	businessEntityControl: UntypedFormControl;
	businessEntityType: { label: string; value: string }[] = [];

	legalAddressStreetControl: UntypedFormControl;
	legalAddressStreet2Control: UntypedFormControl;
	legalAddressCityControl: UntypedFormControl;
	legalAddressStateControl: UntypedFormControl;
	legalAddressPostalCodeControl: UntypedFormControl;
	legalBusinessNameControl: UntypedFormControl;

	legalFormGroup: UntypedFormGroup;

	sectionComplete: boolean = false;

	taxIdControl: UntypedFormControl;

	constructor(public app: AppService, private validatorService: FormValidationService) {}

	ngOnInit(): void {
		for (const [k, v] of Object.entries(FocusPayEntityType)) {
			this.businessEntityType.push({
				label: k,
				value: v,
			});
		}
		if (
			this.application.legalAddress &&
			this.application.merchantAddress &&
			this.application.legalAddress.street !== this.application.merchantAddress.street
		) {
			this.applicationAddressLegalDifferentFromBusiness = true;
		}

		this.applicationAddressLegalDifferentFromBusinessControl = new UntypedFormControl({
			value: this.applicationAddressLegalDifferentFromBusiness,
			disabled: this.readOnly,
		});
		this.businessEntityControl = new UntypedFormControl({ value: this.application.entityType, disabled: this.readOnly }, [Validators.required]);
		this.legalBusinessNameControl = new UntypedFormControl({ value: this.application.legalBusinessName, disabled: this.readOnly }, [Validators.required]);
		this.legalAddressCityControl = new UntypedFormControl({ value: this.application.legalAddress.city, disabled: this.readOnly || true }, []);
		this.legalAddressStateControl = new UntypedFormControl({ value: this.application.legalAddress.state, disabled: this.readOnly || true }, []);

		this.legalAddressPostalCodeControl = new UntypedFormControl({ value: this.application.legalAddress.postalCode, disabled: this.readOnly || true }, []);
		this.legalAddressStreetControl = new UntypedFormControl({ value: this.application.legalAddress.street, disabled: this.readOnly || true }, []);
		this.legalAddressStreet2Control = new UntypedFormControl({ value: this.application.legalAddress.street2, disabled: this.readOnly || true }, []);
		this.taxIdControl = new UntypedFormControl({ value: this.application.taxId, disabled: this.readOnly }, [Validators.required, Validators.pattern(/^[0-9-]*$/)]);
		this.enableLegalAddress();
		setTimeout(() => {
			this.inputAction();
		}, 500);
	}

	inputAction(inputEvent?) {
		inputEvent && this.inputActionEmitter.emit(inputEvent);
		this.sectionStatus.next({
			section: "legal",
			complete: false,
		});
		this.sectionComplete = false;
		if (!this.legalBusinessNameControl.pristine && this.legalBusinessNameControl.errors) return;
		if (!this.businessEntityControl.pristine && this.businessEntityControl.errors) return;
		if (!this.taxIdControl.pristine && this.taxIdControl.errors) return;
		if (this.applicationAddressLegalDifferentFromBusiness) {
			if (!this.legalAddressCityControl.pristine && this.legalAddressCityControl.errors) return;
			if (!this.legalAddressStateControl.pristine && this.legalAddressStateControl.errors) return;
			if (!this.legalAddressPostalCodeControl.pristine && this.legalAddressPostalCodeControl.errors) return;
			if (!this.legalAddressStreetControl.pristine && this.legalAddressStreetControl.errors) return;
		}

		this.sectionComplete = true;
		this.sectionStatus.next({
			section: "legal",
			complete: true,
		});
	}

	enableLegalAddress(inputEvent?) {
		if (inputEvent?.checked === true) {
			this.legalAddressStreetControl.enable();
			this.legalAddressStreetControl.addValidators(Validators.required);
			this.legalAddressStreet2Control.enable();
			this.legalAddressCityControl.enable();
			this.legalAddressCityControl.addValidators(Validators.required);
			this.legalAddressStateControl.enable();
			this.legalAddressStateControl.addValidators(Validators.required);
			this.legalAddressPostalCodeControl.enable();
			this.legalAddressPostalCodeControl.addValidators([Validators.required, Validators.pattern(/^[0-9]*$/)]);
		} else {
			this.legalAddressStreetControl.disable();
			this.legalAddressStreetControl.clearValidators();
			this.legalAddressStreet2Control.disable();
			this.legalAddressCityControl.disable();
			this.legalAddressCityControl.clearValidators();
			this.legalAddressStateControl.disable();
			this.legalAddressStateControl.clearValidators();
			this.legalAddressPostalCodeControl.disable();
			this.legalAddressPostalCodeControl.clearValidators();
		}
	}
}
